@file:OptIn(InternalResourceApi::class)

package klyph.sample.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/klyph.sample.generated.resources/"

@delegate:ResourceContentHash(-1_744_643_962)
internal val Res.font._dfb3b15c22428b7648124e501bfb995ee1fb7028: FontResource by lazy {
      FontResource("font:_dfb3b15c22428b7648124e501bfb995ee1fb7028", setOf(
        ResourceItem(setOf(), "${MD}font/_dfb3b15c22428b7648124e501bfb995ee1fb7028.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-636_124_670)
internal val Res.font._e022f0694060f7bbe6e7b862e1c3868813134f3c: FontResource by lazy {
      FontResource("font:_e022f0694060f7bbe6e7b862e1c3868813134f3c", setOf(
        ResourceItem(setOf(), "${MD}font/_e022f0694060f7bbe6e7b862e1c3868813134f3c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_036_184_992)
internal val Res.font._e17357d67aa8b3efed6162d0fdb1bad407953195: FontResource by lazy {
      FontResource("font:_e17357d67aa8b3efed6162d0fdb1bad407953195", setOf(
        ResourceItem(setOf(), "${MD}font/_e17357d67aa8b3efed6162d0fdb1bad407953195.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_396_159_304)
internal val Res.font._e1f927705333ff6a7b56c8be65bda2f012688c75: FontResource by lazy {
      FontResource("font:_e1f927705333ff6a7b56c8be65bda2f012688c75", setOf(
        ResourceItem(setOf(), "${MD}font/_e1f927705333ff6a7b56c8be65bda2f012688c75.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_310_185_681)
internal val Res.font._e2c5f4e983083ad568468b6233715b24621c7fc8: FontResource by lazy {
      FontResource("font:_e2c5f4e983083ad568468b6233715b24621c7fc8", setOf(
        ResourceItem(setOf(), "${MD}font/_e2c5f4e983083ad568468b6233715b24621c7fc8.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(659_817_460)
internal val Res.font._e5010c33bafa3fa040ad97797c6435ba37f72ad0: FontResource by lazy {
      FontResource("font:_e5010c33bafa3fa040ad97797c6435ba37f72ad0", setOf(
        ResourceItem(setOf(), "${MD}font/_e5010c33bafa3fa040ad97797c6435ba37f72ad0.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(810_276_823)
internal val Res.font._e6d643bd5bf893035ace95e3f686eaa197efc979: FontResource by lazy {
      FontResource("font:_e6d643bd5bf893035ace95e3f686eaa197efc979", setOf(
        ResourceItem(setOf(), "${MD}font/_e6d643bd5bf893035ace95e3f686eaa197efc979.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_422_699_634)
internal val Res.font._e70aa92480d78191d9853690f3b9155c16a2c04f: FontResource by lazy {
      FontResource("font:_e70aa92480d78191d9853690f3b9155c16a2c04f", setOf(
        ResourceItem(setOf(), "${MD}font/_e70aa92480d78191d9853690f3b9155c16a2c04f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(174_740_090)
internal val Res.font._e731c347dac8ce8e5705fda7fc425a25eb181b0c: FontResource by lazy {
      FontResource("font:_e731c347dac8ce8e5705fda7fc425a25eb181b0c", setOf(
        ResourceItem(setOf(), "${MD}font/_e731c347dac8ce8e5705fda7fc425a25eb181b0c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_510_742_584)
internal val Res.font._e7eaf16d8d4bd8e5de7c96c845908bf367daa4ae: FontResource by lazy {
      FontResource("font:_e7eaf16d8d4bd8e5de7c96c845908bf367daa4ae", setOf(
        ResourceItem(setOf(), "${MD}font/_e7eaf16d8d4bd8e5de7c96c845908bf367daa4ae.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-619_323_536)
internal val Res.font._e83f5bb2c5622f413cb5660ee23e3050443bb48e: FontResource by lazy {
      FontResource("font:_e83f5bb2c5622f413cb5660ee23e3050443bb48e", setOf(
        ResourceItem(setOf(), "${MD}font/_e83f5bb2c5622f413cb5660ee23e3050443bb48e.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_705_749_277)
internal val Res.font._e8640cc40e2c415d4bddcca82c7980deb17b8a05: FontResource by lazy {
      FontResource("font:_e8640cc40e2c415d4bddcca82c7980deb17b8a05", setOf(
        ResourceItem(setOf(), "${MD}font/_e8640cc40e2c415d4bddcca82c7980deb17b8a05.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_833_640_949)
internal val Res.font._e86faead7cc37c0de3ebeed14e694e8b230bc20c: FontResource by lazy {
      FontResource("font:_e86faead7cc37c0de3ebeed14e694e8b230bc20c", setOf(
        ResourceItem(setOf(), "${MD}font/_e86faead7cc37c0de3ebeed14e694e8b230bc20c.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_862_065_724)
internal val Res.font._e8bf3d1821db957ad4df7a20914722bd1ef07d99: FontResource by lazy {
      FontResource("font:_e8bf3d1821db957ad4df7a20914722bd1ef07d99", setOf(
        ResourceItem(setOf(), "${MD}font/_e8bf3d1821db957ad4df7a20914722bd1ef07d99.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_030_505_178)
internal val Res.font._eaa2d3e5dd40112a1a596c09c751f18715027a56: FontResource by lazy {
      FontResource("font:_eaa2d3e5dd40112a1a596c09c751f18715027a56", setOf(
        ResourceItem(setOf(), "${MD}font/_eaa2d3e5dd40112a1a596c09c751f18715027a56.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-493_036_187)
internal val Res.font._eb1457c064801441bea2507edf5c693445f4884e: FontResource by lazy {
      FontResource("font:_eb1457c064801441bea2507edf5c693445f4884e", setOf(
        ResourceItem(setOf(), "${MD}font/_eb1457c064801441bea2507edf5c693445f4884e.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_012_098_295)
internal val Res.font._eb45809244cc7e5a8a0eb90b2929101f80894e96: FontResource by lazy {
      FontResource("font:_eb45809244cc7e5a8a0eb90b2929101f80894e96", setOf(
        ResourceItem(setOf(), "${MD}font/_eb45809244cc7e5a8a0eb90b2929101f80894e96.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_040_574_790)
internal val Res.font._ec3ed2c8efa25005c29efc8e78558f2893b872e3: FontResource by lazy {
      FontResource("font:_ec3ed2c8efa25005c29efc8e78558f2893b872e3", setOf(
        ResourceItem(setOf(), "${MD}font/_ec3ed2c8efa25005c29efc8e78558f2893b872e3.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(236_398_809)
internal val Res.font._ef0463a32abcfe934f1245a16627e62ed892ae82: FontResource by lazy {
      FontResource("font:_ef0463a32abcfe934f1245a16627e62ed892ae82", setOf(
        ResourceItem(setOf(), "${MD}font/_ef0463a32abcfe934f1245a16627e62ed892ae82.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-443_661_620)
internal val Res.font._ef3d9ca0f8652edfc532ecb1959e78dbb624fb89: FontResource by lazy {
      FontResource("font:_ef3d9ca0f8652edfc532ecb1959e78dbb624fb89", setOf(
        ResourceItem(setOf(), "${MD}font/_ef3d9ca0f8652edfc532ecb1959e78dbb624fb89.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_870_409_484)
internal val Res.font._ef7d492bea7d64c4446b0870e9f6c140c351cbc6: FontResource by lazy {
      FontResource("font:_ef7d492bea7d64c4446b0870e9f6c140c351cbc6", setOf(
        ResourceItem(setOf(), "${MD}font/_ef7d492bea7d64c4446b0870e9f6c140c351cbc6.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_655_716_049)
internal val Res.font._f15931debf35ded8c299f8417f76f29fbbe9acde: FontResource by lazy {
      FontResource("font:_f15931debf35ded8c299f8417f76f29fbbe9acde", setOf(
        ResourceItem(setOf(), "${MD}font/_f15931debf35ded8c299f8417f76f29fbbe9acde.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(624_913_198)
internal val Res.font._f27e983fd5712405956661c329d2dee3addb309b: FontResource by lazy {
      FontResource("font:_f27e983fd5712405956661c329d2dee3addb309b", setOf(
        ResourceItem(setOf(), "${MD}font/_f27e983fd5712405956661c329d2dee3addb309b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(131_013_384)
internal val Res.font._f2a71da9076e5386e94fa79a41746f08b73adadc: FontResource by lazy {
      FontResource("font:_f2a71da9076e5386e94fa79a41746f08b73adadc", setOf(
        ResourceItem(setOf(), "${MD}font/_f2a71da9076e5386e94fa79a41746f08b73adadc.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_114_454_690)
internal val Res.font._f41f28aa5137f1b901d660691614242f9536ebfa: FontResource by lazy {
      FontResource("font:_f41f28aa5137f1b901d660691614242f9536ebfa", setOf(
        ResourceItem(setOf(), "${MD}font/_f41f28aa5137f1b901d660691614242f9536ebfa.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_890_090_245)
internal val Res.font._f684e1c44b96889b69d2fc86b9de8b00d31a922b: FontResource by lazy {
      FontResource("font:_f684e1c44b96889b69d2fc86b9de8b00d31a922b", setOf(
        ResourceItem(setOf(), "${MD}font/_f684e1c44b96889b69d2fc86b9de8b00d31a922b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_028_229_819)
internal val Res.font._f70382f9e1dfbd78c488d115bc9a1d8a90aa730f: FontResource by lazy {
      FontResource("font:_f70382f9e1dfbd78c488d115bc9a1d8a90aa730f", setOf(
        ResourceItem(setOf(), "${MD}font/_f70382f9e1dfbd78c488d115bc9a1d8a90aa730f.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-47_690_816)
internal val Res.font._f7831d0274a31880869ee4b1f6ae7b8238f6c80b: FontResource by lazy {
      FontResource("font:_f7831d0274a31880869ee4b1f6ae7b8238f6c80b", setOf(
        ResourceItem(setOf(), "${MD}font/_f7831d0274a31880869ee4b1f6ae7b8238f6c80b.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_085_868_864)
internal val Res.font._f8713aa3b35a2882133042a006845a18b0b3b9c5: FontResource by lazy {
      FontResource("font:_f8713aa3b35a2882133042a006845a18b0b3b9c5", setOf(
        ResourceItem(setOf(), "${MD}font/_f8713aa3b35a2882133042a006845a18b0b3b9c5.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-565_145_813)
internal val Res.font._f9e7483b13000af96f279ea2fc9b85ae2ca36f84: FontResource by lazy {
      FontResource("font:_f9e7483b13000af96f279ea2fc9b85ae2ca36f84", setOf(
        ResourceItem(setOf(), "${MD}font/_f9e7483b13000af96f279ea2fc9b85ae2ca36f84.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_339_511_718)
internal val Res.font._fafd9452b1e2daa63f1205605f3511e621700988: FontResource by lazy {
      FontResource("font:_fafd9452b1e2daa63f1205605f3511e621700988", setOf(
        ResourceItem(setOf(), "${MD}font/_fafd9452b1e2daa63f1205605f3511e621700988.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(129_265_507)
internal val Res.font._fb2f7396e0e3635eee42b0a2fa13e5bd3762ce58: FontResource by lazy {
      FontResource("font:_fb2f7396e0e3635eee42b0a2fa13e5bd3762ce58", setOf(
        ResourceItem(setOf(), "${MD}font/_fb2f7396e0e3635eee42b0a2fa13e5bd3762ce58.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(478_093_426)
internal val Res.font._fd9dbd1949c9e6f91857864c83e6e9077593d76e: FontResource by lazy {
      FontResource("font:_fd9dbd1949c9e6f91857864c83e6e9077593d76e", setOf(
        ResourceItem(setOf(), "${MD}font/_fd9dbd1949c9e6f91857864c83e6e9077593d76e.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_537_127_720)
internal val Res.font._fefc3b01552111e1f96c8616130b732422928b12: FontResource by lazy {
      FontResource("font:_fefc3b01552111e1f96c8616130b732422928b12", setOf(
        ResourceItem(setOf(), "${MD}font/_fefc3b01552111e1f96c8616130b732422928b12.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(863_573_225)
internal val Res.font._fff4bf3df4e88d05251b24d708f82e106e897cc6: FontResource by lazy {
      FontResource("font:_fff4bf3df4e88d05251b24d708f82e106e897cc6", setOf(
        ResourceItem(setOf(), "${MD}font/_fff4bf3df4e88d05251b24d708f82e106e897cc6.woff2", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont2Resources(map: MutableMap<String, FontResource>) {
  map.put("_dfb3b15c22428b7648124e501bfb995ee1fb7028", Res.font._dfb3b15c22428b7648124e501bfb995ee1fb7028)
  map.put("_e022f0694060f7bbe6e7b862e1c3868813134f3c", Res.font._e022f0694060f7bbe6e7b862e1c3868813134f3c)
  map.put("_e17357d67aa8b3efed6162d0fdb1bad407953195", Res.font._e17357d67aa8b3efed6162d0fdb1bad407953195)
  map.put("_e1f927705333ff6a7b56c8be65bda2f012688c75", Res.font._e1f927705333ff6a7b56c8be65bda2f012688c75)
  map.put("_e2c5f4e983083ad568468b6233715b24621c7fc8", Res.font._e2c5f4e983083ad568468b6233715b24621c7fc8)
  map.put("_e5010c33bafa3fa040ad97797c6435ba37f72ad0", Res.font._e5010c33bafa3fa040ad97797c6435ba37f72ad0)
  map.put("_e6d643bd5bf893035ace95e3f686eaa197efc979", Res.font._e6d643bd5bf893035ace95e3f686eaa197efc979)
  map.put("_e70aa92480d78191d9853690f3b9155c16a2c04f", Res.font._e70aa92480d78191d9853690f3b9155c16a2c04f)
  map.put("_e731c347dac8ce8e5705fda7fc425a25eb181b0c", Res.font._e731c347dac8ce8e5705fda7fc425a25eb181b0c)
  map.put("_e7eaf16d8d4bd8e5de7c96c845908bf367daa4ae", Res.font._e7eaf16d8d4bd8e5de7c96c845908bf367daa4ae)
  map.put("_e83f5bb2c5622f413cb5660ee23e3050443bb48e", Res.font._e83f5bb2c5622f413cb5660ee23e3050443bb48e)
  map.put("_e8640cc40e2c415d4bddcca82c7980deb17b8a05", Res.font._e8640cc40e2c415d4bddcca82c7980deb17b8a05)
  map.put("_e86faead7cc37c0de3ebeed14e694e8b230bc20c", Res.font._e86faead7cc37c0de3ebeed14e694e8b230bc20c)
  map.put("_e8bf3d1821db957ad4df7a20914722bd1ef07d99", Res.font._e8bf3d1821db957ad4df7a20914722bd1ef07d99)
  map.put("_eaa2d3e5dd40112a1a596c09c751f18715027a56", Res.font._eaa2d3e5dd40112a1a596c09c751f18715027a56)
  map.put("_eb1457c064801441bea2507edf5c693445f4884e", Res.font._eb1457c064801441bea2507edf5c693445f4884e)
  map.put("_eb45809244cc7e5a8a0eb90b2929101f80894e96", Res.font._eb45809244cc7e5a8a0eb90b2929101f80894e96)
  map.put("_ec3ed2c8efa25005c29efc8e78558f2893b872e3", Res.font._ec3ed2c8efa25005c29efc8e78558f2893b872e3)
  map.put("_ef0463a32abcfe934f1245a16627e62ed892ae82", Res.font._ef0463a32abcfe934f1245a16627e62ed892ae82)
  map.put("_ef3d9ca0f8652edfc532ecb1959e78dbb624fb89", Res.font._ef3d9ca0f8652edfc532ecb1959e78dbb624fb89)
  map.put("_ef7d492bea7d64c4446b0870e9f6c140c351cbc6", Res.font._ef7d492bea7d64c4446b0870e9f6c140c351cbc6)
  map.put("_f15931debf35ded8c299f8417f76f29fbbe9acde", Res.font._f15931debf35ded8c299f8417f76f29fbbe9acde)
  map.put("_f27e983fd5712405956661c329d2dee3addb309b", Res.font._f27e983fd5712405956661c329d2dee3addb309b)
  map.put("_f2a71da9076e5386e94fa79a41746f08b73adadc", Res.font._f2a71da9076e5386e94fa79a41746f08b73adadc)
  map.put("_f41f28aa5137f1b901d660691614242f9536ebfa", Res.font._f41f28aa5137f1b901d660691614242f9536ebfa)
  map.put("_f684e1c44b96889b69d2fc86b9de8b00d31a922b", Res.font._f684e1c44b96889b69d2fc86b9de8b00d31a922b)
  map.put("_f70382f9e1dfbd78c488d115bc9a1d8a90aa730f", Res.font._f70382f9e1dfbd78c488d115bc9a1d8a90aa730f)
  map.put("_f7831d0274a31880869ee4b1f6ae7b8238f6c80b", Res.font._f7831d0274a31880869ee4b1f6ae7b8238f6c80b)
  map.put("_f8713aa3b35a2882133042a006845a18b0b3b9c5", Res.font._f8713aa3b35a2882133042a006845a18b0b3b9c5)
  map.put("_f9e7483b13000af96f279ea2fc9b85ae2ca36f84", Res.font._f9e7483b13000af96f279ea2fc9b85ae2ca36f84)
  map.put("_fafd9452b1e2daa63f1205605f3511e621700988", Res.font._fafd9452b1e2daa63f1205605f3511e621700988)
  map.put("_fb2f7396e0e3635eee42b0a2fa13e5bd3762ce58", Res.font._fb2f7396e0e3635eee42b0a2fa13e5bd3762ce58)
  map.put("_fd9dbd1949c9e6f91857864c83e6e9077593d76e", Res.font._fd9dbd1949c9e6f91857864c83e6e9077593d76e)
  map.put("_fefc3b01552111e1f96c8616130b732422928b12", Res.font._fefc3b01552111e1f96c8616130b732422928b12)
  map.put("_fff4bf3df4e88d05251b24d708f82e106e897cc6", Res.font._fff4bf3df4e88d05251b24d708f82e106e897cc6)
}
